// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__V9T8K","disabled":"FileBtn_disabled__2dLxV","warn":"FileBtn_warn__34UZk","fade":"FileBtn_fade__1_5UD"};